<!-- We have subpages and want the search -->
<app-trainings-subheader></app-trainings-subheader>
<!-- FAB that enables "scroll to top"-function -->
<!-- Conditionally render either the router-outlet for the subpages
OR the searchresults if the user did a search, the search should stay on top of all subpages! -->
@if ((isSearch$ | async) === false) {
  <router-outlet></router-outlet>
} @else {
  <app-search-results [trainings]="results$ | async"></app-search-results>
}
